import type { components } from '@bookingdei/api-client/types';
import { useLanguage } from '../../shell/language-context';
import { HeroSearch } from './hero-search';
import type { PlaceOption } from './hero-location-panel';
import { Ic } from './hx-icon';
import { Count } from './hx-count';
import './hero-search.css';

type Category = components['schemas']['Category'];

// The Home hero (design `.hero`): the Tap · Book · Go stepper, the headline and lead, the
// search in its travelling-light frame, and today's booking count under it. The design's
// "Get the app" pill is left out (owner's call, 5 Nov 2026); the app band further down
// links to /app. The search keeps its panels and its phone flow (hero-search.tsx); only
// its frame is the design's. The count is the server's `stats.bookings_today` (API-86) and
// the pill is absent when it is 0 or missing — a made-up or empty figure is worse than none.
export function HxHero({ categories, places, bookingsToday }: { categories: Category[]; places: PlaceOption[]; bookingsToday: number | undefined }) {
  const { t } = useLanguage();
  return (
    <section className="hero">
      <div className="in">
        <div className="tbg rv" role="img" aria-label={t('hx.hero.tbg')}>
          <span className="st s1">
            <i>
              <Ic id="tap" />
            </i>
            {t('hx.hero.tap')}
          </span>
          <b className="ln" />
          <span className="st s2">
            <i>
              <Ic id="check" />
            </i>
            {t('hx.hero.book')}
          </span>
          <b className="ln" />
          <span className="st s3">
            <i>
              <Ic id="arrow" />
            </i>
            {t('hx.hero.go')}
          </span>
        </div>
        <h1 className="h1 rv" style={{ marginTop: 14 }}>
          {t('hx.hero.title_a')}{' '}
          <br />
          {t('hx.hero.title_b')}
        </h1>
        <p className="lead rv">{t('dc50.hero.sub')}</p>
        <div className="neon rv">
          <HeroSearch categories={categories} places={places} />
        </div>
        {bookingsToday ? (
          <div className="hp rv">
            <span className="pillx">
              <i className="dot live" />
              <b>
                <Count n={bookingsToday} />
              </b>{' '}
              {t('dc50.hero.bookings_today')}
            </span>
          </div>
        ) : null}
      </div>
    </section>
  );
}
